import {productPage} from "../modules/elements.js";
import {getElement} from "../modules/helpers.js";
import productPageSliders from "./productPageSliders.js";
import productPageIncludes from "./productPageIncludes.js";
import renderProductInfo, {findVariation} from "./renderProductInfo.js";
import renderProductItem from "./productItem.js";
import productPageCompare from "./productPageCompare.js";

export default function productItemPage() {
    if (productPage) {
        const {attributes: {defaultAttributes}, images = {...images}} = product;
        const sidebarItem = productPage.querySelector(".product-item__main");
        if (screen.width >= 1024) {
            const sidebarScrollWrapper = sidebarItem.querySelector('.scroll__wrapper');
            let isScroll = false;
            document.addEventListener('scroll', () => {
                if (document.documentElement.scrollTop <= sidebarScrollWrapper.scrollTop) isScroll = false;
                if (!isScroll) sidebarScrollWrapper.scrollTop = document.documentElement.scrollTop;
            })
            sidebarScrollWrapper.addEventListener('scroll', function () {
                if (document.documentElement.scrollTop > (sidebarScrollWrapper.scrollHeight - sidebarScrollWrapper.clientHeight) && this.scrollTop <= (sidebarScrollWrapper.scrollHeight - sidebarScrollWrapper.clientHeight)) {
                    isScroll = true;
                }
                if (this.scrollTop >= document.documentElement.scrollTop) document.documentElement.scrollTop = this.scrollTop;
            })
        }


        let allImages = [];
        for (let key in images) {
            if (key !== 'photos') {
                if (!images[key]) return;
                allImages = [...allImages, ...images[key]];


            } else {
                if (!images[key]) return;
                images[key].forEach(item => {
                    if (!item.colors) return;
                    allImages = [...allImages, ...item.colors]


                })
            }
        }

        const galleryBtn = getElement('[data-modal="gallery"]');
        if (allImages.length < 4) {
            galleryBtn.classList.add('none');
        } else {
            product.allImages = allImages.reduce((acc, n) => {
                const i = acc.findIndex(m => m.id === n.id);
                if (!~i || !acc[i].checked) {
                    acc.push(n);
                    if (~i) {
                        acc.splice(i, 1);
                    }
                }
                return acc;
            }, []);
            ;
            galleryBtn.querySelector('span').innerText = product.allImages.length
        }
        renderProductInfo();
        renderProductItem();
        productPageIncludes();
        productPageCompare();
        productPageSliders();

        if (matchMedia("(max-width: 1023px)").matches) {

            const sidebar = sidebarItem.parentElement;
            const productGallery = productPage.querySelector(
                ".product-item__gallery"
            );
            fixedSidebar();
            window.addEventListener("resize", () => {
                fixedSidebar();
            });

            function fixedSidebar() {
                if (matchMedia("(max-width: 1023px)").matches) {
                    sidebar.classList.add("hide");
                    productGallery.insertAdjacentElement("afterend", sidebarItem);
                } else {
                    sidebar.classList.remove("hide");
                    sidebar.appendChild(sidebarItem);
                }
            }
        }
        document.querySelectorAll('[data-cart]').forEach(cartBtn => {
            cartBtn.dataset.text = cartBtn.innerHTML;
            cartBtn.addEventListener('click', () => {
                cartBtn.innerHTML = `<div class="swiper-lazy-preloader"></div>`
                cartBtn.classList.add('disabled')
                let quantity = productPage.querySelector('[data-product-quantity]').dataset.productQuantity
                document.dispatchEvent(new CustomEvent('uarm_addToCart', {
                    detail: {
                        id: productToCart(productPage),
                        quantity: +quantity,
                        el: cartBtn
                    }
                }));
            })
        })
        if (getElement('[data-modal-review]')) {
            getElement('[data-modal-review]').addEventListener('click', () => {
                productPage.querySelector('[data-modal="reviews"]').click()
            })
        }
    }
}

function productToCart(el) {
    let ids = [];
    if (el.querySelector('[data-fas]')) {

        el.querySelectorAll('.includes-item.active').forEach(item => {
            ids = [item.parentElement.dataset.includesId, ...ids]
        })
        return ids;
    }
    return ids = [el.querySelector('.product-item__main').dataset.productId];
}

export {productToCart}
